<dw-ui-panel [defaultOpenedPanel]="info" [triggers]="triggers()">
  @if (entitySignal()?.id) {
    <div header-start class="mx-3">
      <document-number-tag [docRole]="entitySignal().role" [number]="entitySignal().displayNumber">
      </document-number-tag>
    </div>
  }

  <dw-grid-detail-navigation
    header-actions
    [context]="[GoliathDocumentEntityNames.SupplierReturnNote.shortName]"
  >
  </dw-grid-detail-navigation>
  <dw-grid-tabs>
    <div class="tabs">
      <ul
        ngbNav
        #nav="ngbNav"
        (navChange)="onTabChanged($event.nextId)"
        class="nav-underline nav-tabs d-flex border-0 me-md-auto"
      >
        <li [ngbNavItem]="'general'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-alert-info me-2 text-primary"></i>{{ '::General' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <div class="mt-2 container-panel">
                <form
                  id="generalForm"
                  [formGroup]="form"
                  [DwKeyboardShortcut]="shortcut.controlS"
                  (shortcutAction)="save()"
                >
                  <div class="card-group mb-3 mt-2 header">
                    <document-core-card
                      [form]="form"
                      [entity]="entity"
                      [readonlyForm]="
                        entity?.returnStatus == SupplierReturnStatus.CheckValuation ||
                        entity?.returnStatus == SupplierReturnStatus.Closed
                      "
                      [dayBookLabel]="'Doc::DayBookReception'"
                      class="card"
                    ></document-core-card>

                    <document-supplier-document-date-card
                      [form]="form"
                      [readonlyForm]="entity?.returnStatus == SupplierReturnStatus.Closed"
                      class="card"
                    >
                      <div class="row row-cols-md-12">
                        <div class="col-md-12 p-0">
                          <label for="returnedDate" class="form-label text-primary">
                            {{ 'Doc::SupplierReturnNote:ReturnedDate' | abpLocalization }}
                          </label>
                          <dw-core-date-picker formControlName="returnedDate"></dw-core-date-picker>
                        </div></div
                    ></document-supplier-document-date-card>

                    <document-supplier-card
                      [form]="form"
                      [thirdPartySelect]="thirdPartySelect"
                      [thirdPartyContacts$]="thirdPartyContacts$"
                      [currencyRateReadonly]="entity?.returnStatus == SupplierReturnStatus.Closed"
                      [readonlyForm]="
                        entity?.returnStatus == SupplierReturnStatus.CheckValuation ||
                        entity?.returnStatus == SupplierReturnStatus.Closed
                      "
                      class="card card-double"
                    >
                      <div class="row row-cols-md-12 col-pad" bottom>
                        <div class="col-md-6 p-0">
                          <label for="reference" class="form-label text-primary">
                            {{ 'Doc::CustomerReference' | abpLocalization }}
                          </label>
                          <input type="text" class="form-control" formControlName="reference" />
                        </div></div
                    ></document-supplier-card>

                    <document-supplier-document-status-card
                      [form]="form"
                      [salesPersonSelect]="salesPersonSelect"
                      [readonlyForm]="entity?.returnStatus == SupplierReturnStatus.Closed"
                      class="card"
                    >
                      <div class="col-md-6 p-0" afterSalesPerson>
                        <label for="returnStatus" class="form-label text-primary" dwInputRequired>
                          {{ 'Doc::SupplierReturnNote:SupplierReturnStatus' | abpLocalization }}
                        </label>
                        <ng-select
                          class="form-control"
                          id="returnStatus"
                          formControlName="returnStatus"
                          bindLabel="name.current"
                          bindValue="id"
                          [loading]="enumerationTypeStore.loading()"
                          [items]="supplierReturnStatus() | orderBy: 'order'"
                        >
                        </ng-select>
                      </div>
                    </document-supplier-document-status-card>
                  </div>

                  @if (entity?.id) {
                    <div ngbScrollSpyFragment="products" dwScrollSpyItem [fragment]="'products'">
                      <document-supplier-return-note-lines-grid
                        #supplierReturnNoteLineGrid
                        [supplierReturnNote]="entity"
                        [readonly]="isClosed()"
                        [thirdPartyVatSystem]="thirdParty?.vatSystem"
                        (lineUpdatedEvent)="refreshAfterLineUpdate($event)"
                        (linePricingDetailsEvent)="updatePricingDetails($event)"
                      ></document-supplier-return-note-lines-grid>
                    </div>
                  }
                </form>
              </div>
            </div>
          </ng-template>
        </li>
        <li [ngbNavItem]="'conditions'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-terms me-2 text-primary"></i
            >{{ 'Doc::CustomerQuote:Conditions' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <document-doc-conditions class="d-block" [docForm]="form" [docRoleInput]="docRole">
            </document-doc-conditions>
          </ng-template>
        </li>
        <li [ngbNavItem]="'classification'" [disabled]="!entity?.id">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-classifications me-2 text-primary"></i
            >{{ '::Classifications' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <document-doc-classifications
              class="d-block"
              [form]="form"
              [docClassificationValues]="docClassificationValues$ | async"
            ></document-doc-classifications>
          </ng-template>
        </li>
        <li [ngbNavItem]="'others'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-three-points-horizontal-1 me-2 text-primary"></i
            >{{ 'Doc::CustomerQuote:Others' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <document-doc-supplier-others
              class="d-block"
              [docForm]="form"
              [docRoleInput]="docRole"
            ></document-doc-supplier-others>
          </ng-template>
        </li>
        <li [ngbNavItem]="'annexes'">
          <a ngbNavLink appDwNavLink (click)="fetchAnnexes()">
            <i class="digi-out-text-file me-2 text-primary position-relative">
              <dw-ui-counter [value]="annexesCount"></dw-ui-counter>
            </i>
            {{ 'Doc::Annexes' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <core-annexes-list
              class="d-block"
              [canDownload]="true"
              [canUpload]="true"
              [canDelete]="true"
              [canPreview]="true"
              [canEdit]="true"
              [folderName]="'quote-detail/' + entity?.id"
              [annexes]="annexesAsPromise$ | async"
              (createOrUpdateAnnexes)="createOrUpdateAnnexes($event)"
              (deleteAnnex)="deleteAnnex($event)"
              (deleteAnnexes)="deleteAnnexes($event)"
            ></core-annexes-list>
          </ng-template>
        </li>
      </ul>
      @if (entity?.id) {
        <dw-ui-dropdown-menu [dropdownMenu]="actions()"></dw-ui-dropdown-menu>
      }
      <doc-save-action-buttons [buttons]="saveActionBtns()" [saving]="isSaving()" />
      <button
        (click)="validateStock()"
        class="btn btn-success ms-2"
        [disabled]="!stockValidationSharedLogicService.canStockValidate()"
      >
        {{ 'ERP::ToValidate' | abpLocalization }}
      </button>
    </div>

    <div [ngbNavOutlet]="nav" class="tab-content"></div>
  </dw-grid-tabs>

  <div side-panel-content>
    <dw-ui-side-panel #info [contentTemplate]="bodyTotal">
      <ng-template #bodyTotal>
        <document-side-panel
          [entity]="entity"
          [docService]="docService"
          [linePricingDetails]="linePricingDetails"
          [thirdPartyContact$]="thirdPartyContact$"
          [thirdPartyDocLinkedCount]="thirdPartyDocLinkedCount"
          [contactEmail]="contactEmail"
          [contactPhone]="contactPhone"
          [customerAddress]="customerAddress"
          [accountingCustomerOutstandingDto]="accountingCustomerOutstandingDto"
          [thirdParty]="thirdParty"
          [creditLimit]="creditLimit"
          (redirectToThirdPartyEvent)="redirectToThirdParty($event.thirdPartyId, $event.addContact)"
          [dwReadonlyForm]="entity?.returnStatus == SupplierReturnStatus.Closed"
          [isStockValidatedWarning]="entity?.returnStatus == SupplierReturnStatus.CheckValuation"
        >
          <label for="note" class="form-label text-primary mt-3">{{
            'GoliathCore::Note' | abpLocalization
          }}</label>
          @if (entity != null) {
            <textarea
              name="note"
              class="flex-grow-1"
              resize="none"
              [(ngModel)]="entity.note"
              (input)="updateNote($event)"
            ></textarea>
          }
        </document-side-panel>
      </ng-template>
    </dw-ui-side-panel>
    <dw-ui-side-panel class="side-panel--full" #chatPanel [contentTemplate]="bodyChat">
      <ng-template #bodyChat>
        <dw-core-chat
          [entityId]="entity?.id"
          [entityName]="GoliathDocumentEntityNames.SupplierReturnNote.shortName"
          [entityReference]="entity?.displayNumber"
        ></dw-core-chat>
      </ng-template>
    </dw-ui-side-panel>
  </div>
</dw-ui-panel>
